export const BRAND = {
  name: "ASTA",
  full: "ASTA Health Tech",
  tagline: "Smart wards, built on the hospital you already have.",
  email: "info@astahealthtech.com",
} as const;

export const ROUTES = {
  home: "/",
  solutions: "/solutions",
  platform: "/platform",
  useCases: "/use-cases",
  about: "/about",
  contact: "/contact",
  demo: "/contact?intent=demo",
  /** ASTA client/meeting tracker — external app, opens in a new tab */
  crm: "https://asta-tracker-blush.vercel.app/",
} as const;
